// Cookie consent record: what the visitor allowed, stored in localStorage.

const STORAGE_KEY = "applumo_consent";
const VERSION = 1;

export const OPTIONAL_CATEGORIES = ["preferences", "analytics", "marketing"];
export const OPEN_EVENT = "applumo:cookie-settings";
export const CONSENT_EVENT = "applumo:consent";

export const readConsent = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return raw && raw.version === VERSION ? raw : null;
  } catch {
    return null;
  }
};

export const hasConsent = (category) => category === "necessary" || !!readConsent()?.[category];

export const saveConsent = (choices) => {
  const record = { version: VERSION, necessary: true, ...choices, date: new Date().toISOString() };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    /* storage unavailable: the banner will simply show again next visit */
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: record }));
};

// Lets any link (e.g. "Cookie settings" in the footer) reopen the banner.
export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_EVENT));
